export default {
  title: "",
  subtitle: "Conversion between Internal Accounts",
  path: "conversion_between_internal_account",
  paragraphs: [
    "This request should be used when you need to convert funds held in your internal accounts. Conversions are only allowed between accounts of the same flow type — that is, Cash-in to Cash-in and Cash-out to Cash-out.",
    "The payload is the same for conversions in Brazil, Mexico, Colombia and any other local currencies. Only the field's “currency” and “from_bank_account_id” will need to change to match the country's currency used.",
    "For conversion in Chile, the “value” field should not contain decimal places for cents. E.g.: 15000 (instead of 15000.00)",
    "For the correct bank account to be used in this call, check the Bank Accounts in the upper menu of your portal or in and look for the section named “FacilitaPay pay-in accounts” to find an account that matches the same currency you are using.",
    "Conversions between your internal cash-out accounts allow you to convert funds into local currencies, making them readily available for future payouts. As a result, the payout process becomes faster and more seamless, with minimal friction, since the currency conversion has already been handled in advance.",
    "This is the same flow for all other countries such as Brazil, Mexico, Colombia and Chile. Always remember to replace the exchange_currency and the to_bank_account_id with the appropriate values to match the country you are sending the money to."
  ],
  request: {
    method: "POST",
    endpoint: "/transactions",
    payloads: [
      {
        title: "Example of a conversion Cash-in",
        content: { 
          "transaction": { 
            "currency": "BRL", 
            "exchange_currency": "USD", 
            "value": "1000.00", 
            "from_bank_account_id": "your internal cash-in BRL", 
            "to_bank_account_id": "your internal cash-in USD", 
            "subject_id": "your partner_id" 
          } 
        } 
      },
       {
        title: "Example of a conversion Cash-out",
        content: { 
          "transaction": { 
              "currency": "USD", 
              "exchange_currency": "BRL", 
              "value": "500.00", 
              "from_bank_account_id": "your internal cash-out USD", 
              "to_bank_account_id": "your internal cash-out BRL", 
              "subject_id": "your partner ID" 
            } 
          } 
        },
      {
        title: "Usage of the conversion",
        content: { 
          "transaction": { 
            "currency": "BRL", 
            "exchange_currency": "USD", 
            "value": "1000.00", 
            "from_bank_account_id": "3686155e-f5f6-4e5b-97e7-60473a506b8c", 
            "to_bank_account_id": "74416779-ad7b-4b7c-918e-21598700effd", 
            "subject_id": "d6db1129-0ed3-4da7-9beb-d8c6326465f2" 
          } 
        } 
      }
    ],
    responses:{
    "data": {
      "value": "1000.00",
      "to_bank_account": {
          "routing_number": null,
          "pix_info": null,
          "owner_name": "Biriweb Serviços de Internet Ltd",
          "owner_document_type": null,
          "owner_document_number": "21958642819",
          "nickname": null,
          "internal": true,
          "intermediary_bank_account_id": null,
          "id": "74416779-ad7b-4b7c-918e-21598700effd",
          "iban": null,
          "flow_type": "cash_in",
          "currency": "USD",
          "branch_number": null,
          "branch_country": null,
          "bank": {
              "swift": null,
              "name": "Internal",
              "ispb": null,
              "id": "6facab8d-573e-44d0-a4bd-ce2600368263",
              "country": "BRA",
              "code": "999"
          },
          "account_type": "conta-corrente",
          "account_number": null,
          "aba": null
      },
      "subject_is_receiver": true,
      "subject_id": "d6db1129-0ed3-4da7-9beb-d8c6326465f2",
      "subject": {
        "updated_at": "2025-02-19T19:28:37.690718",
        "status": "approved",
        "social_name": "Biri Web",
        "rfc_pf": null,
        "required_clearance_level": 1,
        "references": [],
        "phone_number": "+55 (18) 99812-1212",
        "phone_country_code": null,
        "phone_area_code": null,
        "net_monthly_average_income": "4000.00",
        "inserted_at": "2020-01-29T05:54:23.518616",
        "id": "d6db1129-0ed3-4da7-9beb-d8c6326465f2",
        "fiscal_country": "Brasil",
        "email": "biri_web@facilitapay.com",
        "document_type": "cpf",
        "document_number": "21958642819",
        "clearance_level": 1,
        "birth_date": "1977-10-13",
        "address_street": "Rua Antonio Pontes Filho",
        "address_state": "SP",
        "address_postal_code": "16201220",
        "address_number": "310",
        "address_neighborhood": null,
        "address_country": "Brasil",
        "address_complement": null,
        "address_city": "Birigui",
        "activity_type": null
      },
      "status": "exchanged",
      "source_name": "Biri Web",
      "source_document_type": "cpf",
      "source_document_number": "21958642819",
      "meta": null,
      "inserted_at": "2025-05-13T18:28:38.188522",
      "id": "748d8794-64dc-4a72-9f84-13b4f01addf4",
      "from_credit_card": null,
      "from_bank_account": {
          "routing_number": null,
          "pix_info": null,
          "owner_name": "Biriweb Serviços de Internet Ltd",
          "owner_document_type": null,
          "owner_document_number": "21958642819",
          "nickname": null,
          "internal": true,
          "intermediary_bank_account_id": null,
          "id": "3686155e-f5f6-4e5b-97e7-60473a506b8c",
          "iban": null,
          "flow_type": "cash_in",
          "currency": "BRL",
          "branch_number": null,
          "branch_country": null,
          "bank": {
              "swift": null,
              "name": "Internal",
              "ispb": null,
              "id": "6facab8d-573e-44d0-a4bd-ce2600368263",
              "country": "BRA",
              "code": "999"
          },
          "account_type": "conta-corrente",
          "account_number": null,
          "aba": null
        },
        "for_exchange": true,
        "exchanged_value": "176.05",
        "exchange_under_request": false,
        "exchange_currency": "USD",
        "estimated_value_until_exchange": false,
        "cleared": true,
        "bank_transaction": {
          "wire_id": null,
          "value": "1000",
          "spei_reference": null,
          "spei_concepto_de_pago": null,
          "source_type": "TED-PRE",
          "source_name": "Biri Web",
          "source_id": "8f95353c-700a-4b9e-95f4-c18cfea54844",
          "source_document_type": "cpf",
          "source_document_number": "21958642819",
          "source_description": "CREDITO POR TED ANTECIPADO",
          "source_branch": null,
          "source_bank_ispb": null,
          "source_bank": null,
          "source_account": null,
          "movement_date": "2025-07-09",
          "iof_value": "3.80",
          "inserted_at": "2025-07-09T19:06:37.868022",
          "id": "a0da1066-3990-4570-8fea-7087e5c644fe",
          "exchanged_value": "167.01",
          "exchange_rate_spot": "5.906",
          "exchange_rate": "5.98773",
          "exchange_id": "b04c546b-2ac1-4520-82db-b9574741f459",
          "exchange_currency": "USD",
          "exchange_approved": false,
          "currency": "BRL"
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/Transaction/TransactionConversionInternalAccount.js